module.exports = __webpack_public_path__ + "img/684C40_776E69_9B7765_758D96-256px.acd616e7.png";